import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { authApi } from '@/api/endpoints/auth'

interface Props {
  open: boolean
  onAccepted: () => void
}

export default function TOSModal({ open, onAccepted }: Props) {
  const [checked, setChecked] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const accept = async () => {
    if (!checked) return
    try {
      setSubmitting(true)
      setError(null)
      await authApi.acceptTos()
      onAccepted()
    } catch (e) {
      setError('Failed to record acceptance. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-xl shadow-xl w-full max-w-xl p-6 hover-raise"
            initial={{ scale: 0.96, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 22 }}
          >
        <h2 className="text-xl font-semibold mb-2">Terms of Service</h2>
        <p className="text-sm text-gray-600 mb-4">You must agree to the Terms of Service to continue.</p>
        <div className="h-48 overflow-y-auto border rounded p-3 mb-3 text-sm">
          <p>Please review the Terms of Service and Privacy Policy available from the footer or Help menu. By checking the box below, you agree to these terms.</p>
        </div>
        <label className="flex items-center gap-2 text-sm mb-3">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>I have read and agree to the Terms of Service and Privacy Policy.</span>
        </label>
        {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
        <div className="flex justify-end gap-2">
          <button className="btn-primary transition-transform duration-200 hover-scale active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-yellow-400/60"
            disabled={!checked || submitting} onClick={accept}>
            {submitting ? 'Saving…' : 'I Agree'}
          </button>
        </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}


